/**
 * A marca do OdontoSDR: o "O" com sorriso.
 *
 * Substitui o placeholder — um `<span>` com a letra "O" pintada por CSS — que
 * servia enquanto não havia identidade. Como SVG inline, ela acompanha o
 * tamanho pedido sem pedir arquivo e sem uma requisição a mais.
 *
 * As cores ficam no próprio SVG, e não em `var(--cor-primaria)`, de propósito:
 * a marca é fixa. Se o tema mudar de cor outra vez, o logotipo não deve mudar
 * junto — foi o que aconteceu com o placeholder, que era azul-esverdeado só
 * porque o tema era.
 */
export default function MarcaLogo() {
  return (
    <svg className="marca-logo" viewBox="0 0 48 48" role="img" aria-label="OdontoSDR">
      <rect width="48" height="48" rx="13" fill="#2563eb" />
      <circle cx="24" cy="23" r="10.5" fill="none" stroke="#fff" strokeWidth="4" />
      <path
        d="M18.5 24.5c1.9 3 9.1 3 11 0"
        fill="none"
        stroke="#fff"
        strokeWidth="2.8"
        strokeLinecap="round"
      />
    </svg>
  );
}
